import { render, staticRenderFns } from "./form.vue?vue&type=template&id=51f6df52&scoped=true"
import script from "./form?vue&type=script&lang=js&external"
export * from "./form?vue&type=script&lang=js&external"
import style0 from "./form.vue?vue&type=style&index=0&id=51f6df52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f6df52",
  null
  
)

export default component.exports